// Образец документа: текст шаблона, поля подсвечены — жёлтые заполнит человек, голубые заполнятся сами.
import { Fragment } from "react";
import type { Paragraph } from "../boot";

export function DocPage({ paragraphs, titles = false }: { paragraphs: Paragraph[]; titles?: boolean }) {
  return (
    <span className="doc-page">
      {(paragraphs || []).map((par, i) => (
        <span key={i} className={["doc-par", `align-${par.align}`, par.indent && "is-indent"].filter(Boolean).join(" ")}>
          {par.parts.map((part, j) => {
            const text = part.field ? part.text || "…" : part.text;
            const content = part.bold ? <b>{text}</b> : text;
            return part.field
              ? <mark key={j} className={part.auto ? "is-auto" : undefined} title={titles ? part.label : undefined}>{content}</mark>
              : <Fragment key={j}>{content}</Fragment>;
          })}
        </span>
      ))}
    </span>
  );
}
